import type { ReactNode } from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import type { User } from 'oidc-client-ts';
import { oidcConfig } from './oidc-config';

const onSigninCallback = (_user: User | void): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <OidcAuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      {children}
    </OidcAuthProvider>
  );
}
